export class CacheService {

  constructor() { }

  put(url: string, obj: any): void {
    localStorage[url] = JSON.stringify(obj);    
  }

  get(url: string): any | undefined {
    const json = localStorage[url];

    if (json !== undefined) {    
      return JSON.parse(json);
    }

    return undefined;
  }

  remove(url: string): void {    
    localStorage[url] = undefined;
  }

  invalidateAll(): void {    
    localStorage.clear();
  }
}